<template>
    <v-img :src="require('@/assets/img/eronet-logo.png')" width="50" class="eronet-logo" alt="HT Eronet"></v-img>
</template>
<script>
export default {
    name: "eronet"
}
</script>
<style lang="scss">
.eronet-logo {
    transition: all .4s ease-in-out;
    filter: grayscale(100%);
    opacity: .3;
    &:hover {
        cursor: pointer;
        filter: grayscale(0%);
        opacity: 1;
    }
}
</style>
